import React from "react";
import { Box, Stack, useTheme } from "@mui/material";
import { useSwiper } from "swiper/react";
import Text from "../../../../_components/Text";
import MyButton from "../../../../_components/MyButton";
import PageLayout from "../../../../_components/PageLayout";
import videoFile from "./OnboardingCreateStrategy.mp4";
import robotBook from "./RobotBook.png";

const OnboardingGettingStarted = () => {
  const theme = useTheme();

  const swiper = useSwiper();
  const handleSlideNext = () => swiper.slideNext();

  return (
    <PageLayout
      bottomButton={
        <MyButton withPaper onClick={handleSlideNext}>
          Watch
        </MyButton>
      }
    >
      <Box
        className="layout"
        sx={{
          backgroundColor: theme.myTheme.colors.bg,
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          padding: "8px 8px 0",
        }}
      >
        <Box sx={{
          height: "400px",
          paddingBottom:"38px",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
        }}>
          <img src={robotBook} width={252} />
          {/* <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          >
            <source src={videoFile} type="video/mp4" />
          </video> */}
        </Box>
        <Stack direction="column" spacing={3} alignItems="center">
          <Text variant="h2">Getting started</Text>
          <Box>
            <Text variant="regular" align="center">
              Watch a 40-second demo and create your first
              <br />
              strategy.
            </Text>
            <Text sx={{marginTop: "8px"}} variant="regular" align="center">
							Start earning today!
            </Text>
          </Box>
        </Stack>
      </Box>
    </PageLayout>
  );
};

export default OnboardingGettingStarted;
